import React, { useState } from 'react';
import { onAuthStateChanged } from '@firebase/auth';
import { auth } from '../services/FirebaseConfig';
import { useSelector, useDispatch } from 'react-redux'

import { Alert, Box, Button, Typography, Snackbar } from '@mui/material';

import ContentContainer from '../components/containers/ContentContainer';
import DrawerLayout from '../components/containers/drawerLayout/DrawerLayout';
import DialogDeleteAllDatas from '../components/dialogs/DialogDeleteAllDatas';
import { deleteAccount, deleteAllDatas } from '../services/database/Users';
import { deleteAllProject } from '../redux/reducers/ProjectsSlice'
import { logout } from '../services/Authentication';
import DialogDeleteAccount from '../components/dialogs/DialogDeleteAccount';

let user;

onAuthStateChanged(auth, currentUser => {
    user = currentUser
})

const Setting = () => {
    const dispatch = useDispatch()

    const allProjects = useSelector(state => state.projects)

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
    const [openDeleteAccountDialog, setOpenDeleteAccountDialog] = useState(false)

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [snackbarMessage, setSnackbarMessage] = useState("");

    const userEmail = user.email;
    const userProvider = user.providerData[0].providerId; // "password" || "google.com"

    const handleDeleteProject = () => {
        deleteAllDatas(allProjects)
            .then(() => {
                dispatch(deleteAllProject())
                setSnackbarSeverity("success")
                setSnackbarMessage("Vos données ont été supprimé avec succès !")
                setOpenSnackbar(true)
            })
            .catch(err => {
                setSnackbarSeverity("error")
                setSnackbarMessage("Une erreur est survenue, merci de réessayer.")
                setOpenSnackbar(true)
            })
    }

    const handleLogout = () => {
        logout()
            .then(() => {
                window.location.reload()
            })
            .catch(err => {
                console.log(err);
            })
    }

    const handleDeleteAccount = () => {
        deleteAccount(allProjects)
            .then(() => {
                dispatch(deleteAllProject())
                handleLogout()
            })
            .catch(err => {
                setSnackbarSeverity("error")
                setSnackbarMessage("Une erreur est survenue, merci de réessayer.")
                setOpenSnackbar(true)
            })
    }

    return (
        <>
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={() => setOpenSnackbar(false)}>
                <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
            <DialogDeleteAllDatas
                open={openDeleteDialog}
                onDialogClose={() => setOpenDeleteDialog(false)}
                onSubmit={() => handleDeleteProject()}
            />
            <DialogDeleteAccount
                open={openDeleteAccountDialog}
                onDialogClose={() => setOpenDeleteAccountDialog(false)}
                onSubmit={() => handleDeleteAccount()}
            />
            <DrawerLayout headerTitle='Paramètres'>
                <ContentContainer>
                    <Typography
                        variant='h1'
                        sx={{ marginBottom: 4, fontSize: { xs: 40, md: 48 } }}
                        fontWeight='bold'
                    >
                        Paramètres
                    </Typography>

                    <Box>
                        <Typography
                            variant='h2'
                            sx={{ marginBottom: 4, fontSize: { xs: 30, md: 36 } }}
                            fontWeight='bold'
                        >
                            Mon compte
                        </Typography>

                        <Box sx={{ marginBottom: 4 }}>
                            <Typography
                                variant='h2'
                                sx={{ marginBottom: 2, fontWeight: "500" }}
                                fontSize={20}
                            >
                                E-mail :
                            </Typography>
                            <Typography sx={{ marginRight: 4 }}>
                                {userEmail}
                            </Typography>
                        </Box>
                        {userProvider === "password" ?
                            <Box sx={{ marginBottom: 4 }}>
                                <Typography
                                    variant='h2'
                                    sx={{ marginBottom: 2, fontWeight: "500" }}
                                    fontSize={20}
                                >
                                    Mot de passe :
                                </Typography>

                                <Typography sx={{ marginBottom: 2 }}>
                                    **********
                                </Typography>

                                <Alert severity='info' sx={{ marginBottom: 2 }}>
                                    Votre mot de passe est chiffré avant d'être stocké en base de données, il nous est donc inconnu.
                                </Alert>

                            </Box>
                            :
                            null
                        }


                    </Box>

                    <Box>
                        <Typography
                            variant='h2'
                            sx={{ marginBottom: 4, fontSize: { xs: 30, md: 36 } }}
                            fontWeight='bold'
                        >
                            Supprimer
                        </Typography>

                        <Box sx={{ marginBottom: 4 }}>
                            <Typography
                                variant='h2'
                                sx={{ marginBottom: 2, fontWeight: "500" }}
                                fontSize={20}
                            >
                                Supprimer mes données personnelles :
                            </Typography>

                            <Typography sx={{ marginBottom: 4 }}>
                                Vous souhaitez supprimer toutes vos données de Spliit ? Cliquez  sur le bouton ci-dessous, et tous vos projets et spliits seront supprimés à jamais.
                                Attention, cette action est irréversible ! Une fois supprimées, les données sont irrécupérables.
                            </Typography>

                            <Button onClick={() => setOpenDeleteDialog(true)} variant='contained' color='error'>
                                Supprimer
                            </Button>
                        </Box>

                        <Box sx={{ marginBottom: 4 }}>
                            <Typography
                                variant='h2'
                                sx={{ marginBottom: 2, fontWeight: "500" }}
                                fontSize={20}
                            >
                                Supprimer mon compte :
                            </Typography>

                            <Typography sx={{ marginBottom: 4 }}>
                                Vous souhaitez supprimer votre compte, ainsi que vos données de Spliit ? Cliquez sur le bouton ci-dessous, et tous vos projets et spliits seront supprimés à jamais.
                                Votre compte sera aussi supprimé.
                                Attention, cette action est irréversible ! Une fois supprimées, les données sont irrécupérables.
                            </Typography>

                            <Alert severity='info' sx={{ marginBottom: 4 }}>
                                Merci de vous reconnecter avant d'effectuer cette action, sinon une erreur risque de se produire.
                            </Alert>

                            <Button onClick={() => setOpenDeleteAccountDialog(true)} variant='contained' color='error'>
                                Supprimer
                            </Button>
                        </Box>

                    </Box>

                </ContentContainer>
            </DrawerLayout>
        </>
    )
}

export default Setting;